import { BLOG_CATEGORY, buildBlogFilePath, type BlogMetaData } from '../types';

export const separationAnxietyNursery: BlogMetaData = {
  title: '母子分離不安とは？原因・年齢別の目安・保育園での対処法【保育士解説】',
  description:
    '母子分離不安とは、子どもが保護者と離れる際に感じる自然な発達現象です。母親のせいではない理由、1〜5歳の年齢別の目安、保育園・家庭でできる対処法とNG対応をモンテッソーリ園の園長が解説します。',
  thumbnailUrl: '/img/blog-separation-anxiety-nursery.webp',
  filePath: buildBlogFilePath('separation-anxiety-nursery'),
  category: BLOG_CATEGORY.PARENTING,
};
